module.exports = __webpack_public_path__ + "img/UK.c5b266c6.jpg";